/**
 * src/components/feature/seo/JsonLdInjector.js
 * 
 * Google Gemini-driven Metadata Injection System (G-MITS)
 * Transforms OCR Context Data into Rich Results (JSON-LD)
 */

export const JsonLdInjector = {
    /**
     * Inject JSON-LD Schema
     * @param {Object} metadata
     * @param {string} metadata.title
     * @param {string} metadata.description
     * @param {string} metadata.author
     * @param {string} metadata.datePublished
     * @param {Object} ocrContext - Aggregated context from UniversalViewer
     * @param {string[]} ocrContext.locations - e.g., ["Medieval Castle", "Gangnam"]
     * @param {string[]} ocrContext.vibes - e.g., ["dark", "romantic"]
     */
    inject: ({ title, description, author, datePublished, ocrContext }) => {
        const scriptId = 'mirinae-json-ld-comic';
        let script = document.getElementById(scriptId);

        if (!script) {
            script = document.createElement('script');
            script.id = scriptId;
            script.type = 'application/ld+json';
            document.head.appendChild(script);
        }

        // 1. Base ComicStory Schema
        const schema = {
            "@context": "https://schema.org",
            "@type": "ComicStory",
            "name": title,
            "author": {
                "@type": "Person",
                "name": author
            },
            "datePublished": datePublished,
            "description": description || "A visually stunning episode on Mirinae Platform.",
            "publisher": {
                "@type": "Organization",
                "name": "Mirinae Platform",
                "logo": {
                    "@type": "ImageObject",
                    "url": "https://mirinae.io/logo.png"
                }
            }
        };

        // 2. G-MITS Expansion (Context Injection)
        if (ocrContext) {
            // [SEO] Content Locations
            if (ocrContext.locations && ocrContext.locations.length > 0) {
                schema.contentLocation = ocrContext.locations.map(loc => ({
                    "@type": "Place",
                    "name": loc
                }));
            }

            // [SEO] Keywords (Vibes + Text Samples)
            const keywords = [];
            if (ocrContext.vibes) keywords.push(...ocrContext.vibes);
            if (ocrContext.keywords) keywords.push(...ocrContext.keywords);

            if (keywords.length > 0) {
                schema.keywords = keywords.join(', ');
            }
        }

        script.textContent = JSON.stringify(schema);
        console.log("[G-MITS] JSON-LD Injected:", schema);
    },

    clear: () => {
        const script = document.getElementById('mirinae-json-ld-comic');
        if (script) script.remove();
    }
};
